import request from './http'
// lc-web
export function getLcWeb (data) {
  return request({
    method: 'post',
    url: '/lc-web/api',
    headers: { api_new: 'true' },
    data: data
  })
}
